import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import KitInfoIcon from '../KitInfoIcon';
import colors, { ColorPalette } from '../../common/theme/colors';
import constants from '../../common/theme/constants';
import { isEmpty } from '../../common/utils/KitData';

export interface KitBadgeProps {
  ariaInfoText?: string;
  backgroundColor: keyof ColorPalette;
  badgeText: string;
  borderColor?: string;
  className?: string;
  fontColor: keyof ColorPalette;
  infoText?: string | ReactNode;
}

const Wrapper = styled.div`
  display: flex;
`;

const Badge = styled.div<KitBadgeProps>`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${constants.spacing.absolute.xs}px ${constants.spacing.absolute.sm}px;
  border: solid 1px ${(props) => colors[props.borderColor ?? props.fontColor]};
  border-radius: ${constants.spacing.absolute.sm}px;
  font-size: ${constants.fontSize.text_14}rem;
  color: ${(props) => colors[props.fontColor]};
  background-color: ${(props) => colors[props.backgroundColor]};
  height: ${constants.spacing.absolute.l}px;
  display: inline-flex;
`;

const KitBadge: FunctionComponent<KitBadgeProps> = (props) => {
  const { infoText, badgeText, ariaInfoText } = props;
  if (!isEmpty(infoText)) {
    return (
      <Wrapper className={props.className}>
        <Badge {...props}>{badgeText}</Badge>
        <KitInfoIcon ariaLabel={ariaInfoText} tooltipContent={infoText} />
      </Wrapper>
    );
  }

  return <Badge {...props}>{badgeText}</Badge>;
};

export default KitBadge;
